import React, { FC, useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import { IconButton } from '@savebetter/components';

const NotificationBannerKey = 'isNotificationBannerClosed';

export const NotificationBanner: FC = () => {
  const { storyblokDatasourceEntry } = useStaticQuery(
    graphql`
      query NotificationBannerQuery {
        storyblokDatasourceEntry(data_source: { eq: "notification-banner" }) {
          name
          value
        }
      }
    `
  );

  const isNotificationBannerClosed =
    typeof window !== 'undefined' &&
    storyblokDatasourceEntry &&
    localStorage.getItem(NotificationBannerKey) === storyblokDatasourceEntry.name;
  const [displayNotification, setDisplayNotification] = useState<boolean>(false);

  useEffect(() => {
    setDisplayNotification(storyblokDatasourceEntry && !!storyblokDatasourceEntry.value && !isNotificationBannerClosed);
  }, [storyblokDatasourceEntry, isNotificationBannerClosed]);

  const closeNotificationBanner = () => {
    localStorage.setItem(NotificationBannerKey, storyblokDatasourceEntry.name);
    setDisplayNotification(false);
  };

  if (!displayNotification) {
    return null;
  }

  return (
    <div className="flex justify-center items-center bg-secondary-60 text-white pt-4 pb-4 text-center">
      <span
        className="flex-1 font-light pl-2 pr-2"
        dangerouslySetInnerHTML={{ __html: storyblokDatasourceEntry.value }}
      />
      <IconButton
        iconName="CloseOutlinedIcon"
        className="mr-6"
        iconFontSize="medium"
        onClick={() => closeNotificationBanner()}
      ></IconButton>
    </div>
  );
};
